import { arrayOf, func } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { userShape } from '../../prop-types';
import { fetchUsers } from '../actions';

export default function withUsers() {
  return Component => {
    class ComponentWithUsers extends React.Component {
      componentDidMount() {
        this.props.fetchUsers();
      }

      render() {
        const { users } = this.props;
        const props = {
          ...this.props,
          users,
        };
        return <Component {...props} />;
      }
    }

    ComponentWithUsers.propTypes = {
      users: arrayOf(userShape.isRequired).isRequired,
      fetchUsers: func.isRequired,
    };

    const ConnectedComponentWithUsers = connect(({ users }) => ({ users }), {
      fetchUsers,
    })(ComponentWithUsers);

    ConnectedComponentWithUsers.displayName = `withUsers(${
      Component.displayName || Component.name
    })`;

    return ConnectedComponentWithUsers;
  };
}
